/**
 * 分时段管理 Hook
 *
 * 职责：
 * 1. 增删改分时段条目
 * 2. 时间重叠校验
 */
import { useCallback } from 'react';
import { FormInstance } from 'antd/es/form';
import { validatePickerItem } from '@/utils';
import { DEFAULT_TIME_LIMIT_ITEM } from './useFormInit';

interface UseTimeLimitOptions {
  form: FormInstance;
}

export const useTimeLimit = ({ form }: UseTimeLimitOptions) => {
  /**
   * 校验时间段列表
   * 1. 空值提示"请设置每天生效时间"
   * 2. 两两校验是否存在时间重叠
   */
  const checkTimeLimit = useCallback(
    (data: any[]) => {
      for (let i = 0; i < data.length; i++) {
        const cur = data[i];
        const tempList = data.filter((item: any) => item.id !== cur.id);

        if (!cur.value) {
          cur.errorMes = '请设置每天生效时间';
          continue;
        }

        cur.errorMes = null;
        for (let j = 0; j < tempList.length; j++) {
          const item = tempList[j];
          if (validatePickerItem(cur, item)) {
            cur.errorMes = '生效时间重叠，请重新配置';
            break;
          }
        }
      }

      // 同步到 antd Form
      const currentValues = form.getFieldsValue();
      form.setFieldsValue({ ...currentValues, timeLimit: data });
    },
    [form]
  );

  /**
   * 维护分时段时间段列表
   * @param action 'add' 新增一段；'del' 删除指定段；'edit' 修改指定段
   * @param value 操作的条目（del/edit 时需要）
   */
  const saveTimeLimit = useCallback(
    (action: 'del' | 'add' | 'edit', value?: any) => {
      const currentValues = form.getFieldsValue();
      const currentTimeLimit = currentValues.timeLimit || [];

      let newTimeLimit: any[];

      switch (action) {
        case 'add':
          newTimeLimit = [
            ...currentTimeLimit,
            { id: new Date().getTime(), value: null, errorMes: null },
          ];
          break;

        case 'del':
          newTimeLimit = currentTimeLimit.filter((v: any) => v.id !== value.id);
          break;

        case 'edit':
          newTimeLimit = currentTimeLimit.map((v: any) =>
            v.id === value.id ? value : v
          );
          break;

        default:
          return;
      }

      checkTimeLimit(newTimeLimit);
    },
    [form, checkTimeLimit]
  );

  return { saveTimeLimit };
};
